export const FILTER_OPERATORS = Object.freeze([
  { id: 'eq', label: 'is' },
  { id: 'ne', label: 'is not' },
  { id: 'contains', label: 'contains' },
]);

export function getFilterOperatorLabel(operator) {
  return FILTER_OPERATORS.find((item) => item.id === operator)?.label || operator;
}

export default FILTER_OPERATORS;
